import * as bootstrap from "bootstrap"

window.addEventListener("turbo:frame-load", function(event) {
  const timeout_period_elm= document.querySelector('body[data-controller~="timeout"][data-timeout-period-value]');
  
  if (timeout_period_elm) {
    const timeout_period= timeout_period_elm.dataset.timeoutPeriodValue
    set_timeout_window(timeout_period);
  }
  
});


function set_timeout_window(seconds) {

  // console.log(`Set timer for ${seconds} seconds`);

  clearTimeout(Window.app_timer);

  Window.app_timer= setTimeout(() => {
    console.log(`Timeout after ${seconds} seconds`);

    // First, look for any open Modal to close it
    const currentModalElm= document.querySelector('.modal.show');
    if (currentModalElm) {
      let modal = bootstrap.Modal.getOrCreateInstance(currentModalElm, {});
      if (modal) modal.hide();
    }

    // Now, open the Timeout modal
    const modalElm= document.querySelector('#timeout_modal')
    const modalOptions={};

    let modal = bootstrap.Modal.getOrCreateInstance(modalElm, modalOptions);
    if (modal) {
      modal.show();
    }
  }, seconds*1000);

}

Window.set_timeout_window= set_timeout_window;